/**
 * Overall we want to reuse the Cvent Analytics fact types where possible.  This isn't possible for a few
 * SiteCatalyst fact types.  This object defines those SiteCatalyst-specific fact types.  At some point all of these
 * facts could be moved (along with all others) into a provider-agnostic set of constants.
 *
 * @property {string} CSN_LISTING_CLICK_FACT                       - Used to track clicks of any diamond ads.  This includes
 *                                                              inline (diamond plus), three-diamond, and
 *                                                              four-diamond ads
 * @property {string} CSN_SUGGESTED_AD_CLICK_FACT                  - Used to track clicks of suggested venues from the venue
 *                                                              profile page
 * @property {string} CSN_DIAMOND_PLUS_MAP_CLICK_FACT              - Used to track clicks of diamond plus ads from the map
 *                                                              venue list
 */

export const CSN_LISTING_CLICK_FACT = 'csn-app-ui/analytics/CSN_LISTING_CLICK';
export const CSN_SUGGESTED_AD_CLICK_FACT = 'csn-app-ui/analytics/CSN_SUGGESTED_AD_CLICK';
export const CSN_DIAMOND_PLUS_MAP_CLICK_FACT = 'csn-app-ui/analytics/CSN_DIAMOND_PLUS_MAP_CLICK';
/**
 * SiteCatalyst tracks the type of user action by setting the 'events' variable.  This constant contains the
 * values which may be used for that events variable by this application.
 *
 * @property {string} IMPRESSION_EVENT       - Represents that either a listing or natural result has been viewed by the user
 * @property {string} PROFILE_VIEW_EVENT     - Represents that either a listing or natural result has been clicked by the user
 * @property {string} LISTING_CLICK_EVENT    - Represents that a listing has been clicked by the user.  Should be used in
 *                                              addition to the regular PROFILE_VIEW event
 * @property {string} SEARCH_PERFORMED_EVENT - Represents that any search (initial or repeat) has been performed
 */

export const IMPRESSION_EVENT = 'event7';
export const PROFILE_VIEW_EVENT = 'event8';
export const LISTING_CLICK_EVENT = 'event40';
export const SEARCH_PERFORMED_EVENT = 'event18';

export const SEARCH_SITE_SECTION = 'Search';
export const VENUE_PROFILE_SITE_SECTION = 'Venues';

export const CHANNEL = 'channel';
export const PRODUCTS_TRACKING_VAR = 'products';
export const EVENTS_TRACKING_VAR = 'events';

/**
 * Props are used to capture information and answer questions regarding traffic-related events
 */
export const SEARCH_TERM_ENTERED_BY_USER_PROP = 'prop6';
export const SEARCH_TYPE_INITIAL_OR_REPEAT_PROP = 'prop9';
export const USER_LOGGED_IN_STATUS_AND_SITE_SECTION_PROP = 'prop1';
export const LOGGED_IN_ACCOUNT_USER_ID_PROP = 'prop41';

/**
 * eVars answer questions that tie Success Events back to the last value that was stored in the eVar.  Someone in
 * Marketing probably understands what that means and why it has anything to do with the values we set.
 */
export const USER_LOGGED_IN_STATUS_AND_SITE_SECTION_PLUS_SUBSECTION_OR_VENUE_NAME_AND_CODE_EVAR = 'eVar10';
export const URL_OF_CURRENT_PAGE_EVAR = 'eVar46';
export const NEW_OR_OLD_SEARCH_EVAR = 'eVar51';
export const LOGGED_IN_OR_GUEST_EVAR = 'eVar25';

export const SUPPLIER_NETWORK = 'Supplier Network';
export const NEW_CSN_SRP = 'New CSN SRP';
export const LOGGED_IN_USER = 'Logged-in User';
export const GUEST_USER = 'Guest User';

export const ALL_SITE_CATALYST_TRACKING_VARIABLES = {
  CHANNEL,
  PRODUCTS_TRACKING_VAR,
  EVENTS_TRACKING_VAR,
  SEARCH_TERM_ENTERED_BY_USER_PROP,
  SEARCH_TYPE_INITIAL_OR_REPEAT_PROP,
  USER_LOGGED_IN_STATUS_AND_SITE_SECTION_PROP,
  LOGGED_IN_ACCOUNT_USER_ID_PROP,
  USER_LOGGED_IN_STATUS_AND_SITE_SECTION_PLUS_SUBSECTION_OR_VENUE_NAME_AND_CODE_EVAR,
  URL_OF_CURRENT_PAGE_EVAR,
  NEW_OR_OLD_SEARCH_EVAR,
  LOGGED_IN_OR_GUEST_EVAR
};
